import type { RouteView } from "../hooks/useHashRoute";
import { Icon, type IconName } from "./Icon";

const ITEMS: Array<{ view: RouteView; label: string; icon: IconName }> = [
  { view: "briefing", label: "Briefing", icon: "briefing" },
  { view: "compare", label: "Compare", icon: "compare" },
  { view: "sources", label: "Sources", icon: "sources" },
  { view: "saved", label: "Saved", icon: "saved" },
];

export function BottomNav({ selected, onNavigate }: { selected: RouteView; onNavigate: (view: RouteView) => void }) {
  return (
    <nav className="bottom-nav" aria-label="Primary">
      {ITEMS.map((item) => (
        <button type="button" key={item.view} className={selected === item.view ? "is-selected" : ""} onClick={() => onNavigate(item.view)} aria-current={selected === item.view ? "page" : undefined}>
          <Icon name={item.icon} size={25} />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
